import { copy } from "angular";
import { IWhiteboardShapeState, cloneShape } from "./rendering/shapes";

export const offsetShape = (shape: IWhiteboardShapeState): IWhiteboardShapeState => {
  shape.position.x += 50;
  shape.position.y += 50;
  return shape;
};

export class WhiteboardsClipboard {
  private copiedShapes: IWhiteboardShapeState[] = [];

  copy(...shapes: IWhiteboardShapeState[]): void {
    this.copiedShapes = copy(shapes);
  }

  paste(): IWhiteboardShapeState[] {
    return this.copiedShapes.map((shape) => cloneShape(offsetShape(shape)));
  }

  clear(): void {
    this.copiedShapes = [];
  }
}
